import { PurchaseOrderItemStatus } from '@domain/purchasing';

export const ALL_STATUSES: PurchaseOrderItemStatus[] = [
  PurchaseOrderItemStatus.PLANNED,
  PurchaseOrderItemStatus.IN_PRODUCTION,
  PurchaseOrderItemStatus.PRODUCTION_READY,
  PurchaseOrderItemStatus.IN_TRANSIT,
  PurchaseOrderItemStatus.ARRIVED,
  PurchaseOrderItemStatus.IN_DELIVERY,
  PurchaseOrderItemStatus.AVAILABLE,
];

export const STATUS_LABEL: Record<PurchaseOrderItemStatus, string> = {
  [PurchaseOrderItemStatus.PLANNED]: 'Planned',
  [PurchaseOrderItemStatus.IN_PRODUCTION]: 'In Production',
  [PurchaseOrderItemStatus.PRODUCTION_READY]: 'Production Ready',
  [PurchaseOrderItemStatus.IN_TRANSIT]: 'In Transit',
  [PurchaseOrderItemStatus.ARRIVED]: 'Arrived',
  [PurchaseOrderItemStatus.IN_DELIVERY]: 'In Delivery',
  [PurchaseOrderItemStatus.AVAILABLE]: 'Available',
};

/** Progress rank used to decide whether a milestone is completed. */
export const STATUS_RANK: Record<PurchaseOrderItemStatus, number> = {
  [PurchaseOrderItemStatus.PLANNED]: 0,
  [PurchaseOrderItemStatus.IN_PRODUCTION]: 1,
  [PurchaseOrderItemStatus.PRODUCTION_READY]: 2,
  [PurchaseOrderItemStatus.IN_TRANSIT]: 3,
  [PurchaseOrderItemStatus.ARRIVED]: 4,
  [PurchaseOrderItemStatus.IN_DELIVERY]: 5,
  [PurchaseOrderItemStatus.AVAILABLE]: 6,
};
